// 🥊 Se battre — duel : l'adversaire fonce sur le joueur. Un gant est posé au milieu du chemin :
// sans lui, être touché fait perdre ; une fois ganté, l'adversaire prend la fuite et il faut le
// toucher pour gagner.
import { baseState, countTick, finish, moveRival, sameCell, stepAway, stepToward, timeGain, PREY_REST_EVERY } from './common.js';

/** Contact entre les deux : gagné si le joueur est ganté, perdu sinon. */
const contact = (state, player) => {
  if (!sameCell(state.rival, player)) return state;
  return state.playerBadge ? finish(state, 'win') : finish(state, 'lose', 'beaten');
};

export const fight = {
  id: 'fight',
  create(ctx) {
    const length = Math.max(1, ctx.path.length - 1);
    return baseState(ctx, {
      rival: ctx.path.at(-1),
      budget: Math.max(8, length * 3),
      idleTicks: Math.max(1, Math.ceil(length / 4)),
      items: [ctx.path[Math.floor(length / 2)]],
    });
  },
  tick(state, { grid, player, random }) {
    let next = countTick(state);
    if (next.result) return next;
    if (!next.playerBadge) next = moveRival(next, stepToward(grid, next.rival, player));
    else if (next.ticks % PREY_REST_EVERY !== 0) next = moveRival(next, stepAway(grid, next.rival, player, random));
    return contact(next, player);
  },
  enter(state, { player }) {
    let next = state;
    if (!next.playerBadge && next.items.some((item) => sameCell(item, player))) {
      next = { ...next, items: [], playerBadge: 1 };
    }
    return contact(next, player);
  },
  gain: (state) => timeGain(state.fullGain, state.ticks, state.budget),
  isIdle: (state) => state.ticks >= state.idleTicks,
  hints: (state) => [
    ...state.items.map((cell) => ({ key: 'scenario.fight.hint.goal', cell })),
    { key: 'scenario.fight.hint.rival', cell: state.rival },
  ],
};
